import React from 'react'
import { Button } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'
import { Send } from '@material-ui/icons'
import { Input } from '../components/input/Input'

const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
  maxWidth: 420,
})

const Submit = styled((props) => (
  <Button type="submit" {...props} />
))(({ theme: { spacing } }) => ({
  marginTop: spacing(4),
}))

export function Contact() {
  return (
    <Form name="contact" method="post">
      <input type="hidden" name="form-name" value="contact" />
      <Input id="first-name" label="First name" />
      <Input id="last-name" label="Last name" />
      <Input id="email" type="email" label="Email" required />
      <Input id="enquiry" label="Enquiry" multiline required />
      <Submit
        variant="contained"
        color="secondary"
        endIcon={<Send />}
      >
        Send
      </Submit>
    </Form>
  )
}
